import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  return (
    <section className="relative py-32 overflow-hidden bg-gradient-to-br from-emerald-600 via-teal-600 to-emerald-700">
      {/* Elegant Wave Pattern */}
      <div className="absolute inset-0 opacity-20">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="cta-wave" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
              <path d="M0 100 Q 50 70, 100 100 T 200 100" stroke="white" strokeWidth="2" fill="none" opacity="0.3"/>
              <path d="M0 120 Q 50 90, 100 120 T 200 120" stroke="white" strokeWidth="2" fill="none" opacity="0.2"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cta-wave)" />
        </svg>
      </div>

      {/* Floating Orbs */}
      <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-white rounded-full opacity-10 blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-300 rounded-full opacity-10 blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Elegant Typography */}
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-black text-white mb-8 leading-tight">
            Ready to Scale
            <span className="block text-emerald-200">Your Business?</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-emerald-50 mb-12 max-w-3xl mx-auto leading-relaxed">
            Join businesses scaling with Juniperstandard's fulfillment solutions.
            <span className="block mt-2 font-bold text-white">Get started with a free consultation today.</span>
          </p>

          {/* Elegant Button Group */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-emerald-700 px-10 py-5 rounded-full font-black text-xl hover:shadow-2xl transition-all duration-300 flex items-center space-x-3"
            >
              <span>Get Your Free Quote</span>
              <ArrowRight size={24} />
            </Link>
            
            <Link
              to="/services"
              className="bg-emerald-500/20 backdrop-blur-sm border-2 border-white/30 text-white px-10 py-5 rounded-full font-black text-xl hover:bg-white/20 transition-all duration-300"
            >
              View Our Services
            </Link>
          </div>

          {/* Elegant Trust Indicators */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-emerald-100">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
              <span className="text-sm font-bold">Dedicated Support</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
              <span className="text-sm font-bold">Quality Focused</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
              <span className="text-sm font-bold">Free Consultation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;